import Vue from 'vue'
import ApiService from '@/services/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    isLoadingFair: [],
    isLoadingBooth: [],
    isLoadingBoothCost: [],
    isLoadingBoothInsurance: [],
    isLoadingBoothLinks: [],
    isLoadingBoothAddress: [],
    isLoadingBoothCorrespondenceAddress: [],
    isLoadingBoothDocuments: [],
    isLoadingPastBoothDocuments: [],
    isBoothDocumentsLoaded: [],
    isPastBoothDocumentsLoaded: [],
    isBoothInsuranceLoaded: [],
    reloadFairs: false,
    fairs: [],
    booths: [],
    boothCosts: [],
    boothInsurances: [],
    boothLinks: [],
    boothServiceShopId: null,
    boothAddress: [],
    boothCorrespondenceAddress: [],
    boothDocuments: [],
    pastBoothDocuments: [],
    reloadRubinFairs: false,
    rubinFairs: [],
    rubinBooths: []
  },
  getters: {
    isLoading: state => state.isLoading,
    isLoadingFair: state => id =>
      state.isLoadingFair.find(fairId => fairId === id),
    isLoadingBooth: state => id =>
      state.isLoadingBooth.find(boothId => boothId === id),
    isLoadingBoothCost: state => id =>
      state.isLoadingBoothCost.find(boothId => boothId === id),
    isLoadingBoothInsurance: state => id =>
      state.isLoadingBoothInsurance.find(boothId => boothId === id),
    isLoadingBoothDocuments: state => id =>
      state.isLoadingBoothDocuments.find(boothId => boothId === id),
    isLoadingPastBoothDocuments: state => id =>
      state.isLoadingPastBoothDocuments.find(fair => fair === id),
    isLoadingBoothLinks: state => id =>
      state.isLoadingBoothLinks.find(boothId => boothId === id),
    isLoadingBoothAddress: state => id =>
      state.isLoadingBoothAddress.find(boothId => boothId === id),
    isLoadingBoothCorrespondenceAddress: state => id =>
      state.isLoadingBoothCorrespondenceAddress.find(boothId => boothId === id),
    isBoothDocumentsLoaded: state => id =>
      state.isBoothDocumentsLoaded.find(boothId => boothId === id),
    isPastBoothDocumentsLoaded: state => id =>
      state.isPastBoothDocumentsLoaded.find(fair => fair === id),
    isBoothInsuranceLoaded: state => id =>
      state.isBoothInsuranceLoaded.find(boothId => boothId === id),
    get: state => state.rubinFairs,
    getFair: state => id =>
      state.rubinFairs.find(fair => fair._id === id) || {},
    getFairByCode: state => code =>
      state.rubinFairs.find(
        fair => fair !== undefined && fair.idCode === code
      ) || {},
    getBooth: state => id =>
      state.booths.find(booth => booth.regiNr === id) || {},
    getBoothCost: state => id =>
      state.boothCosts.find(booth => booth.id === id) || [],
    getBoothInsurance: state => id =>
      state.boothInsurances.find(booth => booth.id === id) || {},
    getBoothLinks: state => id =>
      state.boothLinks.find(booth => booth.id === id) || [],
    getBoothAddress: state => (id, addressid) =>
      state.boothAddress.find(booth => booth.id === id) || {},
    getBoothCorrespondenceAddress: state => (id, addressid) =>
      state.boothCorrespondenceAddress.find(booth => booth.id === id) || {},
    getBoothDocuments: state => id =>
      state.boothDocuments.find(booth => booth.id === id) || [],
    getPastBoothDocuments: state => id =>
      state.pastBoothDocuments.find(booth => booth.id === id) || [],
    getBooths: state => state.rubinBooths,
    getWithBooths: state => state.rubinFairs,
    getOneShopFairs: state => state.fairs,
    getOneShopFair: state => id =>
      state.fairs.find(fair => fair._id === id) || {},
    getOneShopFairByCode: state => code =>
      state.fairs.find(fair => fair.idCode === code) || {}
  },
  mutations: {
    isLoading(state, payload) {
      state.isLoading = payload === true
    },
    isLoadingFair(state, payload) {
      if (payload.state) {
        state.isLoadingFair.push(payload.id)
      } else {
        state.isLoadingFair = state.isLoadingFair.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBooth(state, payload) {
      if (payload.state) {
        state.isLoadingBooth.push(payload.id)
      } else {
        state.isLoadingBooth = state.isLoadingBooth.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothCost(state, payload) {
      if (payload.state) {
        state.isLoadingBoothCost.push(payload.id)
      } else {
        state.isLoadingBoothCost = state.isLoadingBoothCost.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothInsurance(state, payload) {
      if (payload.state) {
        state.isLoadingBoothInsurance.push(payload.id)
      } else {
        state.isLoadingBoothInsurance = state.isLoadingBoothInsurance.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothLinks(state, payload) {
      if (payload.state) {
        state.isLoadingBoothLinks.push(payload.id)
      } else {
        state.isLoadingBoothLinks = state.isLoadingBoothLinks.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothAddress(state, payload) {
      if (payload.state) {
        state.isLoadingBoothAddress.push(payload.id)
      } else {
        state.isLoadingBoothAddress = state.isLoadingBoothAddress.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothCorrespondenceAddress(state, payload) {
      if (payload.state) {
        state.isLoadingBoothCorrespondenceAddress.push(payload.id)
      } else {
        state.isLoadingBoothCorrespondenceAddress = state.isLoadingBoothCorrespondenceAddress.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingBoothDocuments(state, payload) {
      if (payload.state) {
        state.isLoadingBoothDocuments.push(payload.id)
      } else {
        state.isLoadingBoothDocuments = state.isLoadingBoothDocuments.filter(
          id => id !== payload.id
        )
      }
    },
    isLoadingPastBoothDocuments(state, payload) {
      if (payload.state) {
        state.isLoadingPastBoothDocuments.push(payload.id)
      } else {
        state.isLoadingPastBoothDocuments = state.isLoadingPastBoothDocuments.filter(
          id => id !== payload.id
        )
      }
    },
    isBoothDocumentsLoaded(state, payload) {
      if (payload.state) {
        state.isBoothDocumentsLoaded.push(payload.id)
      } else {
        state.isBoothDocumentsLoaded = state.isBoothDocumentsLoaded.filter(
          id => id !== payload.id
        )
      }
    },
    isPastBoothDocumentsLoaded(state, payload) {
      if (payload.state) {
        state.isPastBoothDocumentsLoaded.push(payload.id)
      } else {
        state.isPastBoothDocumentsLoaded = state.isPastBoothDocumentsLoaded.filter(
          id => id !== payload.id
        )
      }
    },
    isBoothInsuranceLoaded(state, payload) {
      if (payload.state) {
        state.isBoothInsuranceLoaded.push(payload.id)
      } else {
        state.isBoothInsuranceLoaded = state.isBoothInsuranceLoaded.filter(
          id => id !== payload.id
        )
      }
    },
    setRubinFairs(state, payload) {
      state.rubinFairs = [].concat(payload)
    },
    setReloadRubinFairs(state, payload) {
      state.reloadRubinFairs = payload
    },
    setFairs(state, payload) {
      state.fairs = [].concat(payload)
    },
    setReloadFairs(state, payload) {
      state.reloadFairs = payload
    },
    setBoothCost(state, payload) {
      let existingIndex = state.boothCosts.findIndex(
        booth => booth.id === payload.id
      )
      let boothCostIndex =
        existingIndex >= 0 ? existingIndex : state.boothCosts.length

      Vue.set(state.boothCosts, boothCostIndex, payload)
    },
    setBoothInsurance(state, payload) {
      let existingIndex = state.boothInsurances.findIndex(
        booth => booth.id === payload.id
      )
      let boothInsuranceIndex =
        existingIndex >= 0 ? existingIndex : state.boothInsurances.length

      Vue.set(state.boothInsurances, boothInsuranceIndex, payload)
    },
    setBoothLinks(state, payload) {
      let existingIndex = state.boothLinks.findIndex(
        booth => booth.id === payload.id
      )
      let boothLinksIndex =
        existingIndex >= 0 ? existingIndex : state.boothLinks.length

      Vue.set(state.boothLinks, boothLinksIndex, payload)
    },
    setBoothAddress(state, payload) {
      let existingIndex = state.boothAddress.findIndex(
        booth => booth.id === payload.id
      )
      let boothAddressIndex =
        existingIndex >= 0 ? existingIndex : state.boothAddress.length

      Vue.set(state.boothAddress, boothAddressIndex, payload)
    },
    setBoothCorrespondenceAddress(state, payload) {
      let existingIndex = state.boothCorrespondenceAddress.findIndex(
        booth => booth.id === payload.id
      )
      let boothCorrespondenceAddressIndex =
        existingIndex >= 0
          ? existingIndex
          : state.boothCorrespondenceAddress.length

      Vue.set(
        state.boothCorrespondenceAddress,
        boothCorrespondenceAddressIndex,
        payload
      )
    },
    setBoothDocuments(state, payload) {
      let existingIndex = state.boothDocuments.findIndex(
        booth => booth.id === payload.id
      )
      let boothDocumentIndex =
        existingIndex >= 0 ? existingIndex : state.boothDocuments.length

      Vue.set(state.boothDocuments, boothDocumentIndex, payload)
    },
    setPastBoothDocuments(state, payload) {
      // alert('SET ' + payload.id)
      let existingIndex = state.pastBoothDocuments.findIndex(
        booth => booth.id === payload.id
      )
      let boothDocumentIndex =
        existingIndex >= 0 ? existingIndex : state.pastBoothDocuments.length

      Vue.set(state.pastBoothDocuments, boothDocumentIndex, payload)
    },
    setBooth(state, payload) {
      let existingIndex = state.booths.findIndex(
        booth => booth.regiNr === payload._id
      )
      let boothIndex = existingIndex >= 0 ? existingIndex : state.booths.length
      console.log('setbooth?')
      Vue.set(state.booths, boothIndex, payload)
    },
    updateBoothNotificationState(state, payload) {
      let existingIndex = state.booths.findIndex(
        booth => booth.regiNr === payload[0]
      )
      let boothIndex = existingIndex >= 0 ? existingIndex : state.booths.length

      let tmpBooth = state.booths[boothIndex]
      tmpBooth.taskNotificationStates[payload[1]] = payload[2]

      console.log('setbooth?')
      Vue.set(state.booths, boothIndex, tmpBooth)
    },
    markForReload(state) {
      state.reloadRubinFairs = true
      state.reloadFairs = true
    }
  },
  actions: {
    markForReload(context) {
      context.commit('markForReload')
    },
    async getBooths(context) {
      context.commit('isLoading', true)
      return new Promise((resolve, reject) => {
        ApiService.getRubinFairsWithBooths().then(response => {
          let fairs = []
          response.data.forEach(fair => {
            fair.booths.forEach(booth => {
              let addFair = JSON.parse(JSON.stringify(fair))
              addFair.booth = booth
              fairs.push(addFair)
            })
          })
          context.commit('rubinBooths', fairs)
          context.commit('isLoading', false)
          resolve()
        })
      })
    },
    async getWithBooths(context) {
      context.commit('isLoading', true)
      if (
        context.state.rubinFairs.length > 0 &&
        !context.state.reloadRubinFairs
      ) {
        context.commit('isLoading', false)
        return context.state.rubinFairs
      } else {
        return new Promise((resolve, reject) => {
          ApiService.getRubinFairsWithBooths().then(response => {
            context.commit('setReloadRubinFairs', false)
            context.commit('setRubinFairs', response.data)
            context.commit('isLoading', false)
            resolve()
          })
        })
      }
    },
    async getOneShopFairs(context) {
      if (context.state.fairs.length > 0 && !context.state.reloadFairs) {
        return context.state.fairs.length
      } else {
        return new Promise((resolve, reject) => {
          ApiService.getFairs().then(response => {
            context.commit('setReloadFairs', false)
            context.commit('setFairs', response.data)
            resolve()
          })
        })
      }
    },
    getBoothCost(context, id) {
      context.commit('isLoadingBoothCost', { id, state: true })
      ApiService.getRubinBoothCost(id).then(response => {
        context.commit('setBoothCost', { id: id, data: response.data })
        context.commit('isLoadingBoothCost', { id, state: false })
      })
    },
    resetBoothInsurance(context, id) {
      context.commit('isBoothInsuranceLoaded', { id, state: false })
    },
    getBoothInsurance(context, id) {
      const checkloading = context.state.isLoadingBoothInsurance.find(
        booth => booth === id
      )
      const checkloaded = context.state.isBoothInsuranceLoaded.find(
        booth => booth === id
      )
      if (checkloading === undefined && checkloaded === undefined) {
        context.commit('isLoadingBoothInsurance', { id, state: true })
        ApiService.getInsurance(id).then(response => {
          context.commit('setBoothInsurance', { id: id, data: response.data })
          context.commit('isBoothInsuranceLoaded', { id, state: true })
          context.commit('isLoadingBoothInsurance', { id, state: false })
        })
      }
    },
    getBoothLinks(context, id) {
      context.commit('isLoadingBoothLinks', { id, state: true })

      ApiService.getRubinBoothLinks(id).then(response => {
        context.commit('setBoothLinks', { id: id, data: response.data })
        context.commit('isLoadingBoothLinks', { id, state: false })
      })
    },
    getBoothAddress(context, ids) {
      context.commit('isLoadingBoothAddress', { id: ids[0], state: true })
      ApiService.getRubinBoothAddress(ids[1]).then(response => {
        context.commit('setBoothAddress', { id: ids[0], data: response.data })
        context.commit('isLoadingBoothAddress', { id: ids[0], state: false })
      })
    },
    getBoothCorrespondenceAddress(context, ids) {
      context.commit('isLoadingBoothCorrespondenceAddress', {
        id: ids[0],
        state: true
      })
      ApiService.getRubinBoothAddress(ids[1]).then(response => {
        context.commit('setBoothCorrespondenceAddress', {
          id: ids[0],
          data: response.data
        })
        context.commit('isLoadingBoothCorrespondenceAddress', {
          id: ids[0],
          state: false
        })
      })
    },
    getBoothDocuments(context, id) {
      const checkloading = context.state.isLoadingBoothDocuments.find(
        booth => booth === id
      )
      const checkloaded = context.state.isBoothDocumentsLoaded.find(
        booth => booth === id
      )
      if (checkloading === undefined && checkloaded === undefined) {
        context.commit('isLoadingBoothDocuments', { id, state: true })
        ApiService.getRubinBoothDocuments(id).then(response => {
          context.commit('setBoothDocuments', { id: id, data: response.data })
          context.commit('isLoadingBoothDocuments', { id, state: false })
          context.commit('isBoothDocumentsLoaded', { id, state: true })
        })
      }
    },
    getPastBoothDocuments(context, id) {
      const checkloading = context.state.isLoadingPastBoothDocuments.find(
        fair => fair === id
      )
      const checkloaded = context.state.isPastBoothDocumentsLoaded.find(
        fair => fair === id
      )
      if (checkloading === undefined && checkloaded === undefined) {
        context.commit('isLoadingPastBoothDocuments', { id, state: true })
        ApiService.getRubinPastBoothDocuments(id).then(response => {
          context.commit('setPastBoothDocuments', { id: id, data: response.data })
          context.commit('isLoadingPastBoothDocuments', { id, state: false })
          context.commit('isPastBoothDocumentsLoaded', { id, state: true })
        })
      }
    },
    getBooth(context, id) {
      context.commit('isLoadingBooth', { id, state: true })

      return new Promise((resolve, reject) => {
        ApiService.getRubinBooth(id).then(response => {
          const currState = this.state;
          Object.defineProperty(response.data,'shopzugaenge', {
            get: function() {
              let locale = 'De';
              if (currState.ui.i18n.locale !== undefined && currState.ui.i18n.locale.length > 0) {
                locale = currState.ui.i18n.locale.substr(0,1).toUpperCase() + currState.ui.i18n.locale.substr(1,1);
              }
              return this['shopzugaenge' + locale];
            }
          });
          console.log(response.data);
          context.commit('setBooth', response.data)
          resolve(context.getters.getBooth(id))

          context.commit('isLoadingBooth', { id, state: false })
        })
      })
    },
    updateBoothNotificationState(context, data) {
      context.commit('updateBoothNotificationState', data)
    }
  }
}
